export const data = [
    {
        id: 1,
        name: 'Burguer Tradicional',
        category: 'burguer',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '12.00'
    },
    {
        id: 2,
        name: 'Burguer Double Bife',
        category: 'burguer',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '18.00'
    },
    {
        id: 3,
        name: 'Burguer de Cordeiro',
        category: 'burguer',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '29.00'
    },
    {
        id: 4,
        name: 'Pizza de Frango',
        category: 'pizza',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '18.00'
    },
    {
        id: 5,
        name: 'Pizza Portuguesa',
        category: 'pizza',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '20.00'
    },
    {
        id: 6,
        name: 'Pizza 4 queijos',
        category: 'pizza',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '12.00'
    },
    {
        id: 7,
        name: 'Burguer Tradicional + Fritas',
        category: 'combo',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '12.00'
    },
    {
        id: 8,
        name: 'Pizza de Frango + Refri',
        category: 'combo',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '22.00'
    },
    {
        id: 9,
        name: 'Burguer + Anéis de cebola',
        category: 'combo',
        image: './img/combo.jpg',
        description: 'Queijos, presunto, ovo, tomate, alface',
        price: '24.00'
    },
    {
        id: 10,
        name: 'Suco de laranja',
        category: 'bebidas',
        image: './img/combo.jpg',
        description: 'suco natural de laranja',
        price: '12.00'
    },
    {
        id: 11,
        name: 'Suco de Morango',
        category: 'bebidas',
        image: './img/combo.jpg',
        description: 'suco natural de morango',
        price: '12.00'
    },
    {
        id: 12,
        name: 'Coca-Cola',
        category: 'bebidas',
        image: './img/combo.jpg',
        description: 'Coca-cola 2l',
        price: '12.00'
    },
    {
        id: 13,
        name: 'Torta',
        category: 'sobremesa',
        image: './img/combo.jpg',
        description: 'torta de morango',
        price: '12.00'
    },
    {
        id: 14,
        name: 'Brownie',
        category: 'sobremesa',
        image: './img/combo.jpg',
        description: 'Brownie de gotas de chocolate',
        price: '12.00'
    }
];

export const categories = [
    {
        id:1,
        name: 'Burguer',
        image: 'https://cdn3.iconfinder.com/data/icons/food-beverages-filled-outline/455/Hamburguer-64.png',
    },
    {
        id:2,
        name: 'Pizza',
        image: 'https://cdn0.iconfinder.com/data/icons/fast-food-35/512/fast_food_menu_restaurant-01-64.png',
    },
    {
        id:3,
        name: 'Combo',
        image: 'https://cdn2.iconfinder.com/data/icons/fastfood-25/64/fast-food-restaurant-junk-64.png',
    },
    {
        id:4,
        name: 'Bebidas',
        image: 'https://cdn3.iconfinder.com/data/icons/street-food-and-food-trucker-1/64/beverage-juice-refreshment-soft-drink_-64.png',
    },
    {
        id:5,
        name: 'Sobremesa',
        image: 'https://cdn0.iconfinder.com/data/icons/lifestyle-entertainment-vol-2/512/cake_dessert_sweet_cream-64.png',
    },
]